export const AppStatusMap = {
  on: true,
  off: false,
  busy: true,
  'very-busy': true,
  'off-today': false,
};

export const AppStatuses = {
  ON: 'on',
  OFF: 'off',
  BUSY: 'busy',
  VERY_BUSY: 'very-busy',
  OFF_TODAY: 'off-today',
};

export const MenuStatus = {
  OPEN: 'open',
  PREORDER: 'preOrder',
  CLOSED: 'closed',
};
